import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../../../Shared/store/appContext';
import { canUserEdit } from '../../../../Shared/utils/helpers';
import CustomAlert from '../../../../UiComponentsLibrary/CustomAlert';
import { CustomIconButton } from '../../../../UiComponentsLibrary/CustomIconButton';
import ReusableTable from '../../../../Shared/components/ReusableTable';
import { ArtEventInterface } from '../../../interfaces/editArtEventInterfaces';
import { getFormattedDate } from '../../../../Shared/utils/helpers';
import {
  DataTableActionsFlex,
  EditArtEventTableWrapper,
} from '../EditArtEvent.styles';
import { getTableActionButtons } from '../../../config/actionButtonConfig';
import { TABLE_HEADERS } from '../../../constants/editArtEventTableConstants';

interface TableProps {
  artEventsData: ArtEventInterface[];
  handleDataTableAction: (actionType: string, row: ArtEventInterface) => void;
}

const ActionButtons = ({
  row,
  handleDataTableAction,
  canEdit,
}: {
  row: ArtEventInterface;
  handleDataTableAction: (actionType: string, row: ArtEventInterface) => void;
  canEdit: boolean;
}) => {
  const { t } = useTranslation();
  const buttons = getTableActionButtons(row, canEdit);

  return (
    <DataTableActionsFlex>
      {buttons.map(({ action, config, disabled }) => (
        <CustomIconButton
          key={action}
          icon={config.icon}
          backgroundColor={config.backgroundColor}
          label={t(config.labelKey)}
          handleOnClickCb={() => handleDataTableAction(action, row)}
          disabled={disabled}
        />
      ))}
    </DataTableActionsFlex>
  );
};

const ArtEventTable = ({ artEventsData, handleDataTableAction }: TableProps) => {
  const { t } = useTranslation();
  const { state } = useAppContext();
  const canEdit = canUserEdit(state.currentUser?.permissions);

  if (artEventsData.length === 0) {
    return (
      <CustomAlert alertMessage={t('table-no-data-label')} variant="info" />
    );
  }

  return (
    <EditArtEventTableWrapper>
      <ReusableTable
        tableHeaders={TABLE_HEADERS.map(t)}
        rowsData={artEventsData}
        renderRow={(row) => (
          <>
            <td>
              <ActionButtons
                row={row}
                handleDataTableAction={handleDataTableAction}
                canEdit={canEdit}
              />
            </td>
            <td>{row.artEventID}</td>
            <td>{getFormattedDate(row.startTime)}</td>
            <td>{getFormattedDate(row.endTime)}</td>
            <td>{row.status}</td>
          </>
        )}
      />
    </EditArtEventTableWrapper>
  );
};

export default ArtEventTable;
